const GameStatus = {};

GameStatus.NONE = 0;
GameStatus.TUTORIAL = 1;
GameStatus.PRACTICE = 2;
GameStatus.RUNNING = 3;

export default GameStatus;